<!-- 
 Improvement: Use this later on as a generic template for error messages.
 Let's use it for Unauthorized (No Access), Forbidden Page, Service Temporarily Unavailable
 For now, we're just using it for the No Access page.
-->
<div class="generic-error">
  <div class="generic-error__content">
    <img src="images/user-account-info.svg" alt="No access" class="no-access-icon">
    <div class="caption-container">
      <h3 class="error-title">{{ 'UNAUTHORIZED.NO_ACCESS' | translate }}</h3>
      <span class="error-caption">{{ 'UNAUTHORIZED.PLEASE_REQUEST_ACCESS' | translate }}</span>
    </div>
  </div>
</div>
